import { Box } from '@mui/material';

const SidebarLayout = ({ children, className }) => {

  return (
    <Box className={className} sx={{ display: 'flex', minWidth: 0 }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          // marginLeft: "3vh",
          // padding: 3,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SidebarLayout;
